import { ReactElement, useMemo, useState } from "react";
import { colors, fonts } from "../../Styles";
import { AttentionTypes } from "../../Definitions/valueTypes";
import { CreateAttentionStyles } from "../../Definitions/attentionStyles";
  
interface AttentionListItem_Props {
  attentionType: AttentionTypes,
  systemContent?: ReactElement,
  hover?: boolean,
  onClick?: () => void
}
/**
 * AttentionCard
 * @param attentionType Defines style and header. Could be good, alert, warning or neutral.
 * @param systemContent Content to parse in top content area. 
 * @param problemContent Content to parse in bottom content area.
 * @param hover If true, the card will have opacity: "0.5" and cursor: "pointer" on onMouseEnter.
 * @param onClick Adds an onClick event to the card.
 * @returns A AttentionCard with either good, alert, warning or neutral as type.
 */
export default function AttentionListItem({attentionType, systemContent, onClick, hover = false}: AttentionListItem_Props) {
  const [isHovered, setIsHovered] = useState<boolean>(false); 
  const { textColor, attentionText, attentionColor } = useMemo(() => {
    var _Style = CreateAttentionStyles(attentionType)
    return _Style
  }, [ attentionType ]);

    return(
        <div 
          style={{
            width: "calc(100% - 6px)",
            height: "44px",
            opacity: isHovered? "0.5" : "1",
            cursor: isHovered? "pointer" : "default",
            display: "flex",
            flexDirection: "row",
            border: "3px solid"+attentionColor,
            borderRadius: "10px"
          }} 
          onClick={onClick} 
          onMouseEnter={() => hover&&setIsHovered(true)}
          onMouseLeave={() => hover&&setIsHovered(false)} 
        >
          <div style={{ 
            width: "120px", 
            height: "100%", 
            display: "flex", 
            alignItems: "center", 
            justifyContent: "center",

            textAlign: "center",
            backgroundColor: attentionColor,
             
            ...fonts.header, 
            ...fonts.fontSize4, 
            color: textColor, 
            wordWrap: "break-word", 
            overflowWrap: "break-word",
            borderRight: "3px solid"+attentionColor,
          }}>
            {attentionText}
          </div>
          <div style={{
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            backgroundColor: colors.greyDarkSecondary, 
            borderRadius: "0px 7px 7px 0px",
            paddingLeft: "12px"
          }}>
              {systemContent}
          </div>
        </div>
    )
}